/**
 * This service manage the integration data(Pos, fulfilment)
 * @param _ lodash helpful functions
 * @param integrationConstant static data
 * @param $filter angular service
 * @returns {*}
 */

function integrationSettingsService(_, integrationConstant, gettextCatalog, domainNamesConstant,
                                    integrationDefaultValuesConstant) {
    // this private function creates a default values object,
    // from a constant if the value is not present in the passed data
    const featureDefaultValues = (integrationData, featureDefaultValues) => {
        const matrixName = domainNamesConstant.MAP_FIELD_NAME;
        const defaults = Object.keys(matrixName).reduce((acc, key) => {
            const flattenKeyName = matrixName[key].betterName;

            const getValue = (value, featureDefaultValue) => {
                const flattenDefaultValue = matrixName[key].defaultValue;

                if(value !== undefined) {
                    return value;
                } else if(featureDefaultValue !== undefined) {
                    return featureDefaultValue
                } else {
                    return flattenDefaultValue;
                }
            };
            acc[flattenKeyName] =
                getValue(integrationData[flattenKeyName], featureDefaultValues[flattenKeyName]);
            return acc;
        }, {});

        return _.merge({}, defaults);
    };
    const isPos = (integrationData) => {
        if (integrationData.integration === integrationConstant.INTEGRATION_TYPE.POS.value) {
            return true;
        } else if (integrationData.posType !== undefined ||
            integrationData.posPropertiesCommand && integrationData.posPropertiesCommand.posType) {
            return true;
        } else {
            return false;
        }
    };
    const getPosType = (integrationData) => {
        if (integrationData.posType) {
            return integrationData.posType;
        } else if (integrationData.posPropertiesCommand &&
            integrationData.posPropertiesCommand.posType) {
            return integrationData.posPropertiesCommand.posType;
        }
    };
    // this values are not persisted
    const valuesOnlyToDisplay = (flattenData, integration) =>{
        return {
            integration,
                id: flattenData.id,
            merchantName: flattenData.merchantName
        }
    };
    return {
        updateComtrexSecurityCode(form, response) {
            const securityCode = (response.data && response.data[0] && response.data[0].field) ?
                response.data[0].field : '';
            const comtrexEndpointUrl = (response.data && response.data[1] && response.data[1].field) ?
                response.data[1].field : '';
            const comtrexSecurityProps = {
                securityCode,
                comtrexEndpointUrl
            };
            return _.defaults(comtrexSecurityProps, form);
        },
        updateOmnivoreSettings(form, response){
            const omnivoreEmployeeId = (response.data && response.data[0] && response.data[0].field) ?
                response.data[0].field : '';
            const omnivorePatOrderTypeId = (response.data && response.data[1] && response.data[1].field) ?
                response.data[1].field : '';
            const omnivoreRevenueCenterId = (response.data && response.data[2] && response.data[2].field) ?
                response.data[2].field : '';
            const omnivoreTenderTypeId = (response.data && response.data[3] && response.data[3].field) ?
                response.data[3].field : '';
            const webhookId = (response.data && response.data[4] && response.data[4].field) ?
                response.data[4].field : '';
            const omnivoreValues = {
                omnivoreEmployeeId,
                omnivorePatOrderTypeId,
                omnivoreRevenueCenterId,
                omnivoreTenderTypeId,
                webhookId
            }
            return _.default(omnivoreValues, form)
        },
        copyWithDefaults(newValues, source) {
            return _.defaults(newValues, source);
        },
        merge(obj, destination) {
          return _.merge(obj, destination);
        },
        getIntegrationType() {
            return [
                integrationConstant.INTEGRATION_TYPE.FULFILLMENT,
                integrationConstant.INTEGRATION_TYPE.POS
            ];
        },
        // FIXME this is
        cleanToggleSubFeaturesWhenOff(data) {
            const cleanPatOff = {
                payAtTable: data.value,
                orderAtTable: false,
                payAtTablePosMenuRef: null,
                minPayAtTableNumber: null,
                usePaymentType: false,
                maxPayAtTableNumber: null,
                omnivoreEmployeeId: null,
                omnivorePatOrderTypeId: null,
                omnivoreRevenueCenterId: null,
                omnivoreTenderTypeId: null,
                webhookId: null
            };
            const cleanCollectionOff = {
                collection: data.value,
                collectionWithTimeSlots: false,
                collectionPosMenuRef: null
            };
            const cleanBarOff = {
                barTab: data.value,
                barTabPosMenuRef: null,
                minBarTabTableNumber: null,
                maxBarTabTableNumber: null
            };
            const result = {
                pat: cleanPatOff,
                bar: cleanBarOff,
                col: cleanCollectionOff
            }
            return result[data.type];
        },
        /**
         * @param resetTypeIntegrationDefaultValues when the values are being create at first time
         *  resetTypeIntegrationDefaultValues should be true to set the default value
         *  resetTypeIntegrationDefaultValues false means the data is already persisted
         * @param integrationData integration/pos data is already converted to a flat object and with different
         *  names in same cases
         */
        addDefaultValueAndValidate(integrationFlattenData, resetTypeIntegrationDefaultValues) {
            if (!integrationFlattenData) {
                return {};
            }
            const posType = integrationFlattenData.posType || integrationConstant.POS_TYPE.Micros;
            if (integrationFlattenData.integration === integrationConstant.INTEGRATION_TYPE.POS.value) {
                const valuesToKeep =
                    valuesOnlyToDisplay(integrationFlattenData, integrationFlattenData.integration);
                valuesToKeep.posType = posType;

                // get pos types default value
                const posDefaultValues = integrationDefaultValuesConstant.POS_DEFAULT_VALUES[posType];
                const posDefaultValuesData = this.copyWithDefaults(posDefaultValues, valuesToKeep);

                const dataFromServerOrEmpty = (resetTypeIntegrationDefaultValues ? {} : integrationFlattenData);

                return featureDefaultValues(dataFromServerOrEmpty, posDefaultValuesData);
            } else if (!integrationFlattenData.integration ||
                    integrationFlattenData.integration === integrationConstant.INTEGRATION_TYPE.FULFILLMENT.value) {
                const integration =  integrationFlattenData.integration ||
                    integrationConstant.INTEGRATION_TYPE.FULFILLMENT.value
                const valuesToKeep = valuesOnlyToDisplay(integrationFlattenData, integration);

                const fulfillmentDefaultValues = integrationDefaultValuesConstant
                    .FULFILMENT_DEFAULT_VALUES.defaultType;
                const fulfilmentDefaultValuesData = this.copyWithDefaults(fulfillmentDefaultValues, valuesToKeep);

                const dataFromServerOrEmpty = (resetTypeIntegrationDefaultValues ? {} : integrationFlattenData)
                // for fulfilment collection will always be true even if reset is false or collection is false
                // if it comes false, data must be wrong
                /* eslint-disable fp/no-mutation */
                dataFromServerOrEmpty.collection = true;
                return featureDefaultValues(dataFromServerOrEmpty, fulfilmentDefaultValuesData);
            } else {
                return {};
            }
        },
        // common values from pos that is frequently checked keep all this checks in one place
        // but it needs to be converted to flatten data before call it
        integrationDetails(integrationFlattenData) {
            const posType = getPosType(integrationFlattenData);
            return {
                isPos: isPos(integrationFlattenData),
                isMicros: posType === integrationConstant.POS_TYPE.Micros,
                isComtrex: posType === integrationConstant.POS_TYPE.Comtrex,
                isNcr: posType === integrationConstant.POS_TYPE.Ncr,
                isEunoia: posType === integrationConstant.POS_TYPE.Eunoia,
                isDemo: posType === integrationConstant.POS_TYPE.Demo,
                isQuadranet: posType === integrationConstant.POS_TYPE.Quadranet,
                isIBS: posType === integrationConstant.POS_TYPE.IBS,
                isOmnivore: posType === integrationConstant.POS_TYPE.Omnivore,
                isPilot: posType === integrationConstant.POS_TYPE.Pilot,
                isZonal: posType === integrationConstant.POS_TYPE.Zonal,
                isPaymentez: posType === integrationConstant.POS_TYPE.Paymentez,
                isFulfilment: integrationFlattenData.integration ===
                    integrationConstant.INTEGRATION_TYPE.FULFILLMENT.value,
                isCollection: integrationFlattenData.collection,
                isCollectionWithTimeSlots: integrationFlattenData.collectionWithTimeSlots,
                isPayAtTable: integrationFlattenData.payAtTable,
                isOrderAtTable: integrationFlattenData.orderAtTable,
                isBarTab: integrationFlattenData.barTab
            };
        },
        getPosTypes() {
            return [
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.Micros),
                    value: integrationConstant.POS_TYPE.Micros
                },
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.Comtrex),
                    value: integrationConstant.POS_TYPE.Comtrex
                },
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.Paymentez),
                    value: integrationConstant.POS_TYPE.Paymentez
                },
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.Eunoia),
                    value: integrationConstant.POS_TYPE.Eunoia
                },
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.Quadranet),
                    value: integrationConstant.POS_TYPE.Quadranet
                },
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.Omnivore),
                    value: integrationConstant.POS_TYPE.Omnivore
                },
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.IBS),
                    value: integrationConstant.POS_TYPE.IBS
                },
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.Pilot),
                    value: integrationConstant.POS_TYPE.Pilot
                },
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.Ncr),
                    value: integrationConstant.POS_TYPE.Ncr
                },
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.Zonal),
                    value: integrationConstant.POS_TYPE.Zonal
                },
                {
                    label: gettextCatalog.getString(integrationConstant.POS_TYPE.Demo),
                    value: integrationConstant.POS_TYPE.Demo
                }
            ];
        },
        getIntervals() {
            return [
                {
                    label: '5' + ' ' + gettextCatalog.getString('minutes'),
                    value: 5
                },
                {
                    label:'10' + ' ' + gettextCatalog.getString('minutes'),
                    value: 10
                },
                {
                    label: '15' + ' ' + gettextCatalog.getString('minutes'),
                    value: 15
                },
                {
                    label: '20' + ' ' + gettextCatalog.getString('minutes'),
                    value: 20
                },
                {
                    label: '30' + ' ' + gettextCatalog.getString('minutes'),
                    value: 30
                },
                {
                    label: '45' + ' ' + gettextCatalog.getString('minutes'),
                    value: 45
                },
                {
                    label: '60' + ' ' + gettextCatalog.getString('minutes'),
                    value: 60
                }
            ];
        }
    };
}
angular.module('qkr.integration.settings')
    .factory('integrationSettingsService', integrationSettingsService);



// WEBPACK FOOTER //
// ./src/integration-settings/services/integration.settings.service.js